import React from 'react';
import { APPOINTMENT_STATUS } from '../constants';
import { USER_TYPES } from '../../../auth/constants';
import { isPaidOnline, isPaidOnlineFailed, isReserved } from '../../../common/helpers/appointments';
import { t } from '../../../../modules/infra/i18n';

const getStatusNameAndClass = (appointment) => {
  const { payment, paidInShop, canceledBy, status, paymentStatus } = appointment;

  if (status === APPOINTMENT_STATUS.canceled) {
    if (!canceledBy || !canceledBy.cancelByKind) {
      return {
        statusName: t('appointment:status.canceled'),
        statusClass: 'c-status--grey',
      };
    }

    let by = `${t('appointment:status.by')} `;

    switch (canceledBy.cancelByKind) {
      case USER_TYPES.customer:
        by += t('appointment:status.customer');
        break;
      case USER_TYPES.barber:
        by += t('appointment:status.barber');
        break;
      case USER_TYPES.shop:
        by += t('appointment:status.shop');
        break;
      case USER_TYPES.admin:
      case USER_TYPES.regularAdmin:
        by += t('appointment:status.admin');
        break;
      case USER_TYPES.agent:
        by += t('appointment:status.agent');
        break;
      default:
        return {
          statusName: (
            <div>
              {t('appointment:status.cancelled')}
              <br />
              <span className="c-status__span">{by}</span>
            </div>
          ),
          statusClass: 'c-status--grey',
        };
    }
  }

  if (isPaidOnline(payment)) {
    if (paymentStatus === APPOINTMENT_STATUS.partiallyPaid) {
      return {
        statusName: t('appointment:status.partially_paid'),
        statusClass: 'c-status--green',
      };
    }

    return {
      statusName: t('appointment:status.paid'),
      statusClass: 'c-status--green',
    };
  }

  if (isPaidOnlineFailed(payment)) {
    return {
      statusName: t('appointment:status.failed_payment'),
      statusClass: 'c-status--red',
    };
  }

  if (paidInShop) {
    return {
      statusName: (
        <div>
          {t('appointment:status.paid')}
          <br />
          <span className="c-status__span">{t('appointment:status.in_shop')}</span>
        </div>
      ),
      statusClass: 'c-status--green',
    };
  }

  if (isReserved(payment)) {
    return {
      statusName: t('appointment:status.reserved'),
      statusClass: 'c-status--green',
    };
  }

  return {
    statusName: t('appointment:status.unpaid'),
    statusClass: 'c-status--red',
  };
};

export default getStatusNameAndClass;
